/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
import { distributorService } from '../../service/distributor.service';

export const getIds = (selected) => {
    const arr = [];

    selected.map((val) => {
        arr.push(val.collection_id);
    });
    return arr;
};
export const Addtowishlist = async (item, selected) => {
    const payload = {
        collection_ids: getIds(selected),
        AWS_CLASSIFICATION: item.AWS_CLASSIFICATION,
        CATEGORY_ID: String(item.CATEGORY_ID),
        CONCATENATED_SEGMENTS: item.CONCATENATED_SEGMENTS,
        CURRENCY_CODE: item.CURRENCY_CODE,
        DELIVERY_LEAD_TIME: item.DELIVERY_LEAD_TIME,
        DESCRIPTION: item.DESCRIPTION,
        DIAMETER: item.DIAMETER,
        IMAGE_NAME: item.IMAGE_NAME,
        INVENTORY_ITEM_ID: String(item.INVENTORY_ITEM_ID),
        INVENTORY_ITEM_STATUS_CODE: item.INVENTORY_ITEM_STATUS_CODE,
        LENGTH: item.LENGTH,
        LIST_PRICE: item.LIST_PRICE,
        MAIN_CATEGORY: item.MAIN_CATEGORY,
        METHOD_OF_PACKING: item.METHOD_OF_PACKING,
        MINIMUM_ORDER_QUANTITY: item.MINIMUM_ORDER_QUANTITY,
        MODEL_DESCRIPTION: item.MODEL_DESCRIPTION,
        PACKING_SIZE: item.PACKING_SIZE,
        PRIMARY_UOM_CODE: item.PRIMARY_UOM_CODE,
        STOCK_ONHAND_QTY: item.STOCK_ONHAND_QTY,
    };
    const data = await distributorService.AddTowishlist(payload);
    return data;
};
export const WishlistedProduct = async () => {
    let final = [];
    const products = await distributorService.AllwhishListProducts();
    if (products.data.success_status && products.data.data.length > 0) {
        final = products.data.data;
    }
    return final;
};

export const WishlistExist = (item, id) => {
    let idx = -1;
    item?.map((val) => {
        if (idx === -1) {
            if (val.INVENTORY_ITEM_ID == id) {
                idx = 0;
            }
        }
    });
    return idx > -1;
};
